import { createListenerMiddleware } from '@reduxjs/toolkit'
import * as Analytics from 'analytics/analytics'
import { trackPageView } from 'analytics/snowplow/events'
import { waitPageViewDataLoaded } from '../analytics/snowplow/helpers'
import { reportClientError } from 'services/errorReportingService'
// Create instance
export const analyticsListenerMiddleware = createListenerMiddleware()

const pageChangedBetweenWait = (oldState:App.State, newState:App.State) => {
  return oldState.routeHistory.currentPath !== newState.routeHistory.currentPath
}

analyticsListenerMiddleware.startListening({
  type: 'PAGE_VIEW',
  effect: async(action, listenerApi) => {
    const state = listenerApi.getState() as App.State
    if (state.routeHistory.currentPath === state.routeHistory.prevPath) return
    // check conditions for awaiting specific redux state data
    const waitedFor = await waitPageViewDataLoaded(state, listenerApi)
    const newState = listenerApi.getState() as App.State
    if (waitedFor.length > 0 && pageChangedBetweenWait(state, newState)) {
      // report this until the full issue is resolved
      reportClientError(new Error('Analytics page changed while waiting for data'), {
        oldPage: state.routeHistory.currentPath,
        newPage: newState.routeHistory.currentPath,
      })
    }
    Analytics.track('page-view', trackPageView(state.routeHistory.currentPath, state.routeHistory.currentPathParams))
  },
})
